import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useAuth } from '../../shared/auth/useAuth';
import { getDashboardKpis, getDashboardPending, getDashboardTrend } from './api';
import type {
  DashboardKpisDto,
  DashboardKpisQuery,
  DashboardPendingDto,
  DashboardTrendDto,
  DashboardTrendQuery,
} from './types';

export function useDashboardKpis(
  query: DashboardKpisQuery,
): UseQueryResult<DashboardKpisDto, Error> {
  return useQuery({
    queryKey: ['dashboard', 'kpis', query],
    queryFn: () => getDashboardKpis(query),
    staleTime: 60_000,
  });
}

export function useDashboardPending(): UseQueryResult<DashboardPendingDto, Error> {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['dashboard', 'pending', user?.perfil],
    queryFn: () => getDashboardPending(),
    enabled: Boolean(user),
    staleTime: 60_000,
  });
}

export function useDashboardTrend(
  query: DashboardTrendQuery,
): UseQueryResult<DashboardTrendDto, Error> {
  return useQuery({
    queryKey: ['dashboard', 'trend', query],
    queryFn: () => getDashboardTrend(query),
    staleTime: 60_000,
  });
}
